
import _ from 'lodash';
import { isStringValid } from 'shared/lib/validators';
import trimTrailingParagraph from 'shared/lib/trimTrailingParagraph';
import { DATA_LANGUAGES, DEFAULT_DATA_LANGUAGE_CODE } from 'shared/constants';

export const buildIntlAttribute = (entity, attrName, intlSourceObject = 'intl') => DATA_LANGUAGES
  .reduce((acc, curr) => {
    acc[curr] = entity[intlSourceObject] && entity[intlSourceObject][curr] && entity[intlSourceObject][curr][attrName]
      ? entity[intlSourceObject][curr][attrName]
      : entity[attrName];
    return acc;
  }, { default: entity[attrName] });

export const buildInitialIntlAttribute = value => DATA_LANGUAGES.reduce((acc, curr) => {
  acc[curr] = value;
  return acc;
}, { default: value });

export const isAnyIntlAttributeValid = (intlAttr, validationFn, formatter = v => v) => DATA_LANGUAGES
  .map(lng => intlAttr[lng]).some(value => validationFn(formatter(value)));

export const isAnyIntlStringValid = intlAttr => isAnyIntlAttributeValid(intlAttr, isStringValid, trimTrailingParagraph);

export const getDefaultIntlAttributeValue = (intlAttr) => {
  if (_.isEmpty(intlAttr)) {
    return null;
  }

  if (intlAttr.default) {
    return intlAttr.default;
  }

  if (intlAttr[DEFAULT_DATA_LANGUAGE_CODE]) {
    return intlAttr[DEFAULT_DATA_LANGUAGE_CODE];
  }

  return Object.values(intlAttr).filter(Boolean)[0] || null;
};

export const getAllNonDefaultIntlValues = (source, attributes = []) => {
  if (_.isEmpty(source) || attributes.length === 0) {
    return [];
  }

  return DATA_LANGUAGES.map((language) => {
    const langData = attributes.reduce((acc, attribute) => {
      const defaultValue = getDefaultIntlAttributeValue(source[attribute]);
      if (source[attribute][language] && source[attribute][language] !== defaultValue) {
        acc[attribute] = source[attribute][language];
        acc.language = language;
      }

      return acc;
    }, {});

    if (!_.isEmpty(langData)) {
      return langData;
    }

    return null;
  }).filter(Boolean);
};

export const getOtherAvailableAttributeLangs = (attribute, currentLang, validatorFn = isStringValid) =>
  !validatorFn(attribute[currentLang]) ? Object.keys(attribute).filter(key => validatorFn(trimTrailingParagraph(attribute[key]))) : [];

export const getIntlValues = attribute => Object.entries(attribute);

export default {
  buildIntlAttribute,
  buildInitialIntlAttribute,
  isAnyIntlAttributeValid,
  isAnyIntlStringValid,
  getDefaultIntlAttributeValue,
  getAllNonDefaultIntlValues,
  getOtherAvailableAttributeLangs,
  getIntlValues,
};
